import {
  combineReducers,
} from 'redux';
import extendedReducer from './configurator/index';
import product from './product';
import productInfo from './productInfo/index';
import skuMap from './skuMap/index';
import config from './config';
import thdStoreInfo from './thdStoreInfo';
import deliveryInfo from './deliveryInfo';
import canonicalUrl from './canonicalUrl';
import choiceAndSkuAvailability from './choiceAndSkuAvailability';
import choiceInit from './choiceInit';
import earliestDeliveryInfo from './earliestDeliveryInfo';
import cartProduct from './cartProduct';
import pageMetaOverview from './pageMeta';
import errorGroups from './errorGroups';
import isPreviewProduct from '../utils/isPreviewProduct';
import {
  hydrationReducer,
} from './hydrationReducer';
import {
  analyticsReducer,
} from './analytics';

let reducers = {
  configurator: extendedReducer,
  product,
  productInfo,
  skuMap,
  config,
  thdStoreInfo,
  deliveryInfo,
  canonicalUrl,
  choiceAndSkuAvailability,
  choiceInit,
  earliestDeliveryInfo,
  hydration: hydrationReducer,
  cartProduct,
  pageMetaOverview,
  analytics: analyticsReducer
};

if (isPreviewProduct) {
  reducers = { ...reducers, errorGroups };
}

const rootReducer = combineReducers(reducers);

export default rootReducer;
